import React from "react";
import { Container, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  UiButton,
  UiTextIconButton,
} from "../../_uiComponents/common/UiButton";
import NotCustomer from "../../../styles/img/onboard/not-customer.png";
import { hideError } from "../../../_redux/_actions";

export const NoCustomerPage = (props) => {
  const { t } = useTranslation();
  const naviagate = useNavigate();
  const dispatch = useDispatch();

  const goToLogin = () => {
    dispatch(hideError());
    naviagate("/");
  };

  return (
    <>
      <div className="df-user-profile df-onboard-progress-back-close df-profile-top-aligned-box">
        <Container maxWidth="md" className="df-pos-rel">
          <div className="df-user-profile__body df-pw-tab">
            <Grid container>
              <Grid size={{ xs: 12, sm: 6, lg: 6, xl: 6 }} className="df-pr-2">
                <img src={NotCustomer} className="df-verify-progress-img" />
              </Grid>

              <Grid
                size={{ xs: 12, sm: 6, lg: 6, xl: 6 }}
                className="text-center df-pl-2"
              >
                <div className="df-onboard-radio df-verify-progress">
                  <h4>{t("You are not a LOLC Customer")}</h4>
                  <p>{t("Explore our services and join the LOLC family!")}</p>

                  <div className="df-onboard-ext-links">
                    <a
                      className="df-primary-underlined-btn df-modal-support-text"
                      target="_blank"
                      href={`${process.env.OPEN_LOLC_ACC_LINK}`}
                    >
                      {t("Click here for LOLC Accounts")}
                    </a>

                    <a
                      className="df-primary-underlined-btn df-modal-support-text second-link"
                      target="_blank"
                      href={`${process.env.APPLY_CREDIT_CARD_LINK}`}
                    >
                      {t("Click here for LOLC Credit Cards")}
                    </a>
                  </div>

                  <div className="df-not-cus-text">
                    <p>{t("For further assistance, please contact")} </p>

                    <div className="df-onboarding-alert-customer-support">
                      <a
                        className="df-primary-underlined-btn df-modal-support-text"
                        href={`tel:${process.env.SUPPORT_CENTER_CONTACT_NUMBER}`}
                      >
                        {process.env.SUPPORT_CENTER_CONTACT_NUMBER_LABEL}
                      </a>
                    </div>
                  </div>

                  <UiButton
                    className="df-ui-dark-bg-btn w-100 df-onboard-radio-btn mt-2 df-no-cus-btn"
                    name={t("Ok")}
                    onClick={goToLogin}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
    </>
  );
};
